import { MDTApi } from './mdtapi.js';

export const fetchInventoryWishlistId = async () => {
    return await MDTApi.call('api.inventory.getCartId', {
      method: 'GET',
    }, {
      cartType: 'BILLREP'
    });
  };

  export const fetchConsumptionCart = async (cartid) => {
    if (!cartid) {
        throw new Error('Missing required parameter cartId')
    }

    return MDTApi.call('api.wishlist.cartItems', {
        method: 'GET',
        params: {
            encapsulateSuccessor: true
        },
    },
        { cartid }
    );
};  